import React, { useState, useEffect, forwardRef, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ajaxconfig } from "../ajaxconfig";
import ReactQuill from './ReactQuillFixed';
import { delete_cbt_question, job_status, job_uploads, MassPrivateQuestionExport, upload_docx} from "../serverurl";
import { Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { CbtDataIdPrivateCbtDataVerify, CbtQuestionCreate, Deletecbtdata,mass_question_insert, MassPrivateQuestionGet, CbtDataIdGetCbt, CbtDataIdCreateCbt } from "../serverurl";
import { Sidebar } from '../dashboard_component';
import MyTextEditor from './MyTextEditor';
import { upload_file, ImgFile, private_all_asset, private_delete_asset } from "../serverurl";
import { ajax_config_file } from '../ajax_config_file';

const hidden = { display: 'none' };
const visible = { display: 'block' };

const CbtData = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [question, setQuestion] = useState("");
    const [score, setScore] = useState(1);
    const [question_type_id, setQuestionTypeId] = useState("objectives");
    const [sort, setSort] = useState(1);
    const [dbQuestions, setDbQuestions] = useState([]);
    const url_param = new URLSearchParams(window.location.search);
    const cbt_data_passcode = url_param.get("cbt_data_id"); 
    const [question_status, setQuestionStatus] = useState("draft");
    const [display_sort, setDisplaySort] = useState("true");
    const [score_style, setScoreStyle] = useState(hidden);
    const [sort_style, setSortStyle] = useState(hidden);
    const [button_active, setButtonActive] = useState(visible);
    const [button_effect, setButtonEffect] = useState(hidden);
    const [cbtData, setCbtData] = useState("");
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showShareModal, setShowShareModal] = useState(false);
    const [importQuestionModal, setImportQuestionShareModal] = useState(false);
    const [exportQuestionModal, setExportQuestionShareModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const navigate = useNavigate();
    const mass_question_url = MassPrivateQuestionGet + cbt_data_passcode;
    const mass_question_export_url = MassPrivateQuestionExport + cbt_data_passcode;
    const [cbtName, setCbtName] = useState("");
    const [attemptLimit, setAttemptLimit] = useState(1);
    const [defaultScore, setDefaultScore] = useState(1);
    const [cbtDuration, setCbtDuration] = useState("");
    const [maxQuestion, setMaxQuestion] = useState("");
    const [randomQuestion, setRandomQuestion] = useState("no");
    const [cbtStatus, setCbtStatus] = useState('draft');
    const [db_img_files, set_db_img_file] = useState([]);
    const [loading, setLoading] = useState(false);
    const [Questionstatus, setQuestionstatus] = useState(false);
    const [dataExport, setDataExport] = useState([]);
    const [exportLoading, setExportLoading] = useState(false);
    const [exportStatus, setExportStatus] = useState('');

    const handleToggle = () => setIsCollapsed(!isCollapsed);
    const config = ajaxconfig();
    const config_upload = ajaxconfig();
    const [selectedFile, setSelectedFile] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const [uploadStatus, setUploadStatus] = useState('');
    const [passcode, setPasscode] = useState(cbt_data_passcode);
    const [dataServer, setDataServer] = useState({});
    const fileInputRef = useRef(null);
    const [previewData, setPreviewData] = useState(null);
    const [showPreviewModal, setShowPreviewModal] = useState(false);

    const handlePreview = () => {
        setShowPreviewModal(true);
    };

    const handleConfirmUpload = () => {
        dataUpload();
        setShowPreviewModal(false);
        setImportQuestionShareModal(false);
    };

    const dataUpload = () => {
        const data = {
            cbt_pass_code: cbt_data_passcode,
            questions: dataServer
        }

        setIsProcessing(true);
        axios.post(mass_question_insert, data, config).then((response) => {
            toast.success(response.data.message);
            refreshQuestions();
            setShowPreviewModal(false);
            setImportQuestionShareModal(false);
            setIsProcessing(false);
        }).catch((error) => {
            toast.error('Please try again...');
            setIsProcessing(false);
        });
    }

    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (file && (file.type === 'application/pdf' || 
                     file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')) {
            setSelectedFile(file);
            setUploadStatus('');
        } else {
            setUploadStatus('Please select a PDF or DOCX file');
        }
    };

    const handleUpload = async () => {
        if (!selectedFile) {
            setUploadStatus('Please select a file first');
            return;
        }

        if (!cbt_data_passcode) {
            setUploadStatus('Please enter the passcode');
            return;
        }

        setIsProcessing(true);
        setUploadStatus('Processing your file...');

        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('cbt_pass_code', cbt_data_passcode);

        try {
            const response = await axios.post(upload_docx, formData, config_upload);
            setDataServer(response.data);

            if (response.status === 200) {
                setUploadStatus('File uploaded successfully! Questions are being processed.');
                setDataServer(response.data);
                setIsProcessing(false);
                setPreviewData(response.data); 
            } else {
                setUploadStatus(`Upload failed: ${response.statusText}`);
                setIsProcessing(false);
            }
        } catch (error) {
            setUploadStatus(error.response?.data?.detail || 'Upload failed');
            setIsProcessing(false);
        }
    };

    const refresh_img = () => {
        axios.get(private_all_asset, config).then((response) => {
            set_db_img_file(Array.isArray(response.data.img_files) ? response.data.img_files : []);
        }).catch((error) => {
            toast.error('Please try again...');
        });
    };

    // Enhanced Export function with loading state
    const handleExport = async () => {
        setExportLoading(true);
        setExportStatus('Processing questions for export...');
        
        try {
            const response = await axios.get(mass_question_export_url, config);
            
            if (response.data.export && response.data.export.length > 0) {
                setDataExport(response.data.export);
                
                // Filename from url param
                const url_param = new URLSearchParams(window.location.search);
                const cbt_data_passcode = url_param.get("cbt_data_id") || "questions";

                // Convert to JSON string
                const jsonStr = JSON.stringify(response.data.export, null, 2);

                // Create blob and trigger download
                const blob = new Blob([jsonStr], { type: "application/json" });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = `${cbt_data_passcode}_questions.json`;
                link.click();
                
                setExportStatus('Export completed successfully!');
                toast.success('Questions exported successfully!');
            } else {
                setExportStatus('No data available for export');
                toast.info('No questions available for export');
            }
        } catch (error) {
            console.error('Export error:', error);
            setExportStatus('Export failed. Please try again.');
            toast.error('Export failed. Please try again.');
        } finally {
            setExportLoading(false);
            setTimeout(() => setExportStatus(''), 3000);
        }
    };

    useEffect(() => {
        const url = CbtDataIdPrivateCbtDataVerify + cbt_data_passcode;
        axios.get(url, config).then((response) => {
            if (response.data.data.cbt_data_id) {
                setCbtData(response.data.data);
            }
        }).catch(console.error);

        refresh_img();
        
        axios.get(mass_question_url, config).then((response) => {
            if (response.data.data) {
                setDbQuestions(response.data.data);
                setDataExport(response.data.export);
            }
        }).catch((err) => {
            console.log(err);
        });
    }, []);

    const refreshQuestions = () => {
        axios.get(mass_question_url, config).then((response) => {
            if (response.data.data) {
                setDbQuestions(response.data.data);
                toast.success(response.data.message);
            }
        }).catch(console.error);
    }

    const submitQuestion = (event) => {
        event.preventDefault();
        if (!question.trim()) {
            toast.error("CBT question cannot be empty");
            return;
        }

        setQuestionstatus(true);
        
        const data = {
            question: question,
            cbt_data_id: cbt_data_passcode,
            score: score,
            question_type_id: question_type_id,
            display_sort: display_sort, 
            cbt_question_status: question_status,
            sort: sort
        }
        
        axios.post(CbtQuestionCreate, data, config)
            .then(() => {
                setShowCreateModal(false);
                refreshQuestions();
                setQuestionstatus(false);
                setQuestion("");
            })
            .catch((error) => {
                toast.error(error.message);
                setQuestionstatus(false);
            });
    }

    const handleChange = (value) => setQuestion(value);

    const handleCopyText = () => {
        navigator.clipboard.writeText(cbtData.cbt_data_id)
            .then(() => toast.success("Link copied to clipboard!"))
            .catch(() => toast.error("Failed to copy text"));
    };

    const handleCopyLink = () => {
        const link = "https://app.cbthost.com/qr_verification?cbt_pass_code=" + cbtData.cbt_data_id;
        navigator.clipboard.writeText(link)
            .then(() => toast.success("Link copied to clipboard!"))
            .catch(() => toast.error("Failed to copy link"));
    };

    function deleteQuestion(question) {
        setButtonActive(hidden);
        setButtonEffect(visible);
        const data = { cbt_question_id: question.cbt_question_id };
        
        axios.post(delete_cbt_question, data, config)
            .then((response) => {
                toast.success(response.data.message);
                setShowDeleteModal(false);
                refreshQuestions();
            })
            .catch((error) => {
                toast.error(error.message);
            })
            .finally(() => {
                setButtonActive(visible);
                setButtonEffect(hidden);
            });
    }

    const fetchCbtData = () => {
        setLoading(true);
        axios.get(CbtDataIdGetCbt, config)
            .then((response) => {
                setCbtData(response.data.data || []);
                toast.success(response.data.message);
            })
            .catch((error) => {
                toast.error(error.message || "Failed to fetch CBT data");
            })
            .finally(() => setLoading(false));
    }

    return (
        <div className="flex min-h-screen bg-gray-50">
            <Sidebar isCollapsed={isCollapsed} onToggle={handleToggle} />
            
            <div className={`flex-1 transition-all duration-300 pt-16 lg:pt-5 ${isCollapsed ? 'lg:ml-20' : 'lg:ml-64'}`}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    {/* Header Section */}
                    <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl shadow-xl overflow-hidden mb-8">
                        <div className="p-6 md:p-8 text-white">
                            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                                <div className="flex-1">
                                    <h1 className="text-2xl md:text-3xl font-bold mb-2 flex items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                        </svg>
                                        {cbtData.cbt_name || 'CBT Management'}
                                    </h1>
                                    <p className="text-blue-100 text-sm md:text-base">Manage your questions and exam settings</p>
                                </div>
                                <button 
                                    className="bg-white text-blue-600 hover:bg-blue-50 px-6 py-3 rounded-xl font-semibold flex items-center gap-2 transition-all duration-200 hover:scale-105 shadow-lg"
                                    onClick={() => setShowCreateModal(true)}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
                                    </svg>
                                    Create Question
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Stats Cards */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                        <div className="bg-white rounded-xl shadow-sm p-6 border-l-4 border-blue-500">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-sm font-medium text-gray-600">Total Questions</p>
                                    <p className="text-2xl font-bold text-gray-900">{dbQuestions.length}</p>
                                </div>
                                <div className="p-3 bg-blue-100 rounded-lg">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white rounded-xl shadow-sm p-6 border-l-4 border-green-500">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-sm font-medium text-gray-600">CBT Status</p>
                                    <p className={`text-lg font-bold capitalize ${cbtData.cbt_status === 'active' ? 'text-green-600' : 'text-yellow-600'}`}>
                                        {cbtData.cbt_status || 'Draft'}
                                    </p>
                                </div>
                                <div className="p-3 bg-green-100 rounded-lg">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white rounded-xl shadow-sm p-6 border-l-4 border-purple-500">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-sm font-medium text-gray-600">Passcode</p>
                                    <p className="text-lg font-bold text-gray-900 font-mono">{cbtData.cbt_data_id || 'N/A'}</p>
                                </div>
                                <div className="p-3 bg-purple-100 rounded-lg">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white rounded-xl shadow-sm p-6 border-l-4 border-orange-500">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-sm font-medium text-gray-600">Default Score</p>
                                    <p className="text-2xl font-bold text-gray-900">{cbtData.default_score || 1}</p>
                                </div>
                                <div className="p-3 bg-orange-100 rounded-lg">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-orange-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Quick Actions */}
                    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 mb-8">
                        <div className="p-6 border-b border-gray-100">
                            <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                </svg>
                                Quick Actions
                            </h2>
                        </div>
                        <div className="p-6">
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                                <button 
                                    className="flex items-center gap-3 p-4 bg-blue-50 hover:bg-blue-100 rounded-xl transition-all duration-200 group"
                                    onClick={() => setShowShareModal(true)}
                                >
                                    <div className="p-2 bg-blue-500 rounded-lg group-hover:scale-110 transition-transform">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
                                            <path d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" />
                                        </svg>
                                    </div>
                                    <span className="font-medium text-gray-700">Share CBT</span>
                                </button>

                                <a 
                                    href={'/cbt_creator/test_result/' + cbtData.cbt_data_id} 
                                    className="flex items-center gap-3 p-4 bg-green-50 hover:bg-green-100 rounded-xl transition-all duration-200 group"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <div className="p-2 bg-green-500 rounded-lg group-hover:scale-110 transition-transform">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 0l-4-4a1 1 0 101.414 1.414L8 10.414l1.293 1.293a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <span className="font-medium text-gray-700">View Results</span>
                                </a>

                                <button 
                                    className="flex items-center gap-3 p-4 bg-purple-50 hover:bg-purple-100 rounded-xl transition-all duration-200 group"
                                    onClick={() => navigate('/qr_verification?cbt_pass_code=' + cbt_data_passcode)}
                                >
                                    <div className="p-2 bg-purple-500 rounded-lg group-hover:scale-110 transition-transform">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M3 4a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 2V5h1v1H5zm-2 7a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2v-1h1v1H5zm8-12a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V4a1 1 0 00-1-1h-3zm1 2v1h1V5h-1z" clipRule="evenodd" />
                                            <path d="M11 4a1 1 0 10-2 0v1a1 1 0 002 0V4zM10 7a1 1 0 011 1v1h2a1 1 0 110 2h-3a1 1 0 01-1-1V8a1 1 0 011-1zM16 9a1 1 0 100 2 1 1 0 000-2zM9 13a1 1 0 100-2H7a1 1 0 100 2h2zM13 13a1 1 0 110-2h2a1 1 0 110 2h-2z" />
                                        </svg>
                                    </div>
                                    <span className="font-medium text-gray-700">QR Code</span>
                                </button>

                                <button 
                                    className="flex items-center gap-3 p-4 bg-orange-50 hover:bg-orange-100 rounded-xl transition-all duration-200 group"
                                    onClick={() => setImportQuestionShareModal(true)}
                                >
                                    <div className="p-2 bg-orange-500 rounded-lg group-hover:scale-110 transition-transform">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6h.1a5 5 0 011 9.9M12 12v6m0 0l-3-3m3 3l3-3" />
                                        </svg>
                                    </div>
                                    <span className="font-medium text-gray-700">Import Questions</span>
                                </button>

                                <button 
                                    className="flex items-center gap-3 p-4 bg-indigo-50 hover:bg-indigo-100 rounded-xl transition-all duration-200 group"
                                    onClick={() => setExportQuestionShareModal(true)}
                                >
                                    <div className="p-2 bg-indigo-500 rounded-lg group-hover:scale-110 transition-transform">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6h.1a5 5 0 011 9.9M12 8v8m0 0l-3-3m3 3l3-3" />
                                        </svg>
                                    </div>
                                    <span className="font-medium text-gray-700">Export Questions</span>
                                </button>

                                <a 
                                    href={'/cbt_creator/test_data_upload/' + cbt_data_passcode}
                                    className="flex items-center gap-3 p-4 bg-red-50 hover:bg-red-100 rounded-xl transition-all duration-200 group"
                                >
                                    <div className="p-2 bg-red-500 rounded-lg group-hover:scale-110 transition-transform">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                        </svg>
                                    </div>
                                    <span className="font-medium text-gray-700">Import Students</span>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Questions Navigation */}
                    {dbQuestions.length > 0 && (
                        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 mb-8">
                            <div className="p-6 border-b border-gray-100">
                                <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                                    </svg>
                                    Question Navigation
                                </h2>
                            </div>
                            <div className="p-6">
                                <div className="flex flex-wrap gap-3">
                                    {dbQuestions.map((_, index) => (
                                        <a 
                                            key={index}
                                            className="w-12 h-12 bg-blue-100 hover:bg-blue-200 text-blue-800 flex items-center justify-center rounded-xl font-semibold transition-all duration-200 hover:scale-110 shadow-sm"
                                            href={`#question${index}`}
                                        >
                                            {index + 1}
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Questions List */}
                    <div className="bg-white rounded-2xl shadow-sm border border-gray-100">
                        <div className="p-6 border-b border-gray-100">
                            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                                <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                                    </svg>
                                    Questions ({dbQuestions.length})
                                </h2>
                                {dbQuestions.length > 0 && (
                                    <div className="flex items-center gap-2 text-sm text-gray-500">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                        Click on question numbers above to navigate quickly
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="p-6">
                            {dbQuestions.map((question, index) => (
                                <QuestionLoop 
                                    key={index}
                                    i={index}
                                    question={question}
                                    cbt_pass_code={cbt_data_passcode}
                                    refresh_question={refreshQuestions}
                                    onDeleteClick={(q) => {
                                        setCurrentQuestion(q);
                                        setShowDeleteModal(true);
                                    }}
                                />
                            ))}
                            
                            {dbQuestions.length === 0 && (
                                <div className="text-center py-12">
                                    <div className="max-w-md mx-auto">
                                        <div className="w-24 h-24 mx-auto mb-6 bg-blue-100 rounded-full flex items-center justify-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                            </svg>
                                        </div>
                                        <h3 className="text-xl font-semibold text-gray-700 mb-2">No Questions Yet</h3>
                                        <p className="text-gray-500 mb-6">Get started by creating your first question or importing existing ones</p>
                                        <div className="flex flex-col sm:flex-row gap-3 justify-center">
                                            <button 
                                                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl font-medium flex items-center justify-center gap-2 transition-colors"
                                                onClick={() => setShowCreateModal(true)}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
                                                </svg>
                                                Create First Question
                                            </button>
                                            <button 
                                                className="border border-gray-300 hover:bg-gray-50 text-gray-700 px-6 py-3 rounded-xl font-medium flex items-center justify-center gap-2 transition-colors"
                                                onClick={() => setImportQuestionShareModal(true)}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6h.1a5 5 0 011 9.9M12 12v6m0 0l-3-3m3 3l3-3" />
                                                </svg>
                                                Import Questions
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Create Question Modal */}
            <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)} size="lg" centered>
                <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-6 rounded-t-lg">
                    <div className="flex justify-between items-center">
                        <h3 className="text-xl font-bold flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                            </svg>
                            Create New Question
                        </h3>
                        <button 
                            onClick={() => setShowCreateModal(false)}
                            className="text-white hover:text-gray-200 transition-colors"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>
                <div className="bg-white p-6">
                    <form onSubmit={submitQuestion}>
                        <div className="mb-6">
                            <label className="block text-gray-700 font-semibold mb-3">Question Content</label>
                            <MyTextEditor
                                initialContent={question}
                                onChange={handleChange}
                                imageLibrary={db_img_files} 
                            />
                        </div>
                        
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                            <div>
                                <label className="block text-gray-700 font-medium mb-2">Question Status</label>
                                <select 
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                    value={question_status} 
                                    onChange={(e) => setQuestionStatus(e.target.value)}
                                >
                                    <option value="published">Published</option>
                                    <option value="draft">Draft</option>
                                </select>
                            </div>
                            
                            {/* <div>
                                <label className="block text-gray-700 font-medium mb-2">Display Sort</label>
                                <select 
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                    value={display_sort} 
                                    onChange={(e) => setDisplaySort(e.target.value)}
                                >
                                    <option value="true">Yes</option>
                                    <option value="false">No</option>
                                </select>
                            </div> */}
                            
                            <div>
                                <label className="block text-gray-700 font-medium mb-2">Score</label>
                                <input 
                                    type="number" 
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                    value={score} 
                                    onChange={(e) => setScore(e.target.value)} 
                                    min="1"
                                />
                            </div>
{/*                             
                            <div>
                                <label className="block text-gray-700 font-medium mb-2">Sort Order</label>
                                <input 
                                    type="number" 
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                    value={sort} 
                                    onChange={(e) => setSort(e.target.value)} 
                                    min="1"
                                />
                            </div> */}
                        </div>
                        
                        <button
                            type="submit"
                            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-lg font-semibold transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                            disabled={Questionstatus}
                        >
                            {Questionstatus ? (
                                <>
                                    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Saving Question...
                                </>
                            ) : (
                                <>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                    </svg>
                                    Save Question
                                </>
                            )}
                        </button>
                    </form>
                </div>
            </Modal>

            {/* Share Modal */}
            <Modal show={showShareModal} onHide={() => setShowShareModal(false)} centered>
                <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-6 rounded-t-lg">
                    <h3 className="text-xl font-bold flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
                        </svg>
                        Share CBT
                    </h3>
                </div>
                <div className="bg-white p-6">
                    <div className="space-y-6">
                        <div>
                            <label className="block text-gray-700 font-semibold mb-3">Passcode</label>
                            <div className="flex">
                                <input 
                                    type="text" 
                                    className="flex-1 p-3 border border-gray-300 rounded-l-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 font-mono" 
                                    value={cbtData.cbt_data_id || ''} 
                                    readOnly 
                                />
                                <button 
                                    className="bg-gray-200 hover:bg-gray-300 px-4 rounded-r-lg transition-colors flex items-center"
                                    onClick={handleCopyText}
                                >
                                    <i className="fas fa-copy"></i>
                                </button>
                            </div>
                        </div>
                        
                        <div>
                            <label className="block text-gray-700 font-semibold mb-3">Direct Link</label>
                            <div className="flex">
                                <input 
                                    type="text" 
                                    className="flex-1 p-3 border border-gray-300 rounded-l-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 text-sm" 
                                    value={"https://app.cbthost.com/qr_verification?cbt_pass_code=" + cbtData.cbt_data_id} 
                                    readOnly 
                                />
                                <button 
                                    className="bg-gray-200 hover:bg-gray-300 px-4 rounded-r-lg transition-colors flex items-center"
                                    onClick={handleCopyLink}
                                >
                                    <i className="fas fa-copy"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* Import Questions Modal */}
            <Modal show={importQuestionModal} onHide={() => setImportQuestionShareModal(false)} size="lg" centered>
                <div className="bg-gradient-to-r from-orange-500 to-red-500 text-white p-6 rounded-t-lg">
                    <h3 className="text-xl font-bold flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6h.1a5 5 0 011 9.9M12 12v6m0 0l-3-3m3 3l3-3" />
                        </svg>
                        Import Questions
                    </h3>
                </div>
                <div className="bg-white p-6">
                    <div className="mb-6">
                        <label className="block text-gray-700 font-semibold mb-3">
                            Upload Questions File (PDF or DOCX) 
                            <a target='_blank' href="http://cbthost.com/cbt_question_import_via_docx" className="text-blue-600 hover:text-blue-800 text-sm font-normal ml-2">
                                Learn more about accepted formats
                            </a>
                        </label>
                        <input
                            type="file"
                            ref={fileInputRef}
                            accept=".pdf,.docx"
                            onChange={handleFileSelect}
                            className="w-full p-3 border-2 border-dashed border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                            disabled={isProcessing}
                        />
                        {selectedFile && (
                            <p className="mt-2 text-sm text-green-600 font-medium">
                                Selected: {selectedFile.name}
                            </p>
                        )}
                    </div>

                    {uploadStatus && (
                        <div className={`mb-6 p-4 rounded-lg ${uploadStatus.includes('failed') || uploadStatus.includes('error') ? 'bg-red-100 text-red-700 border border-red-200' : 'bg-blue-100 text-blue-700 border border-blue-200'}`}>
                            {uploadStatus}
                        </div>
                    )}

                    <div className="flex justify-end gap-3">
                        <button
                            className="px-5 py-2.5 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors font-medium disabled:opacity-50"
                            onClick={() => {
                                setImportQuestionShareModal(false);
                                setDataServer([]);
                                setUploadStatus('');
                            }}
                            disabled={isProcessing}
                        >
                            Cancel
                        </button>
                        <button
                            className="px-5 py-2.5 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors font-medium disabled:opacity-50 flex items-center gap-2"
                            onClick={handleUpload}
                            disabled={isProcessing || !selectedFile}
                        >
                            {isProcessing ? (
                                <>
                                    <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Processing...
                                </>
                            ) : (
                                'Process File'
                            )}
                        </button>
                        {dataServer && dataServer.length > 0 && (
                            <button
                                className="px-5 py-2.5 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors font-medium"
                                onClick={handlePreview}
                            >
                                Preview Questions
                            </button>
                        )}
                    </div>
                </div>
            </Modal>

            {/* Export Questions Modal */}
            <Modal show={exportQuestionModal} onHide={() => setExportQuestionShareModal(false)} size="md" centered>
                <div className="bg-gradient-to-r from-indigo-500 to-purple-600 text-white p-6 rounded-t-lg">
                    <h3 className="text-xl font-bold flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6h.1a5 5 0 011 9.9M12 8v8m0 0l-3-3m3 3l3-3" />
                        </svg>
                        Export Questions
                    </h3>
                </div>
                <div className="bg-white p-6">
                    <div className="text-center">
                        <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6h.1a5 5 0 011 9.9M12 8v8m0 0l-3-3m3 3l3-3" />
                            </svg>
                        </div>
                        
                        <p className="text-gray-600 mb-2">
                            Export your questions as a JSON file for backup or migration.
                        </p>
                        
                        {exportStatus && (
                            <div className={`mb-4 p-3 rounded-lg text-sm font-medium ${
                                exportStatus.includes('failed') ? 'bg-red-100 text-red-700' : 
                                exportStatus.includes('completed') ? 'bg-green-100 text-green-700' : 
                                'bg-blue-100 text-blue-700'
                            }`}>
                                {exportStatus}
                            </div>
                        )}
                        
                        <div className="flex flex-col gap-3 mt-6">
                            <button
                                className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-3 px-6 rounded-lg font-semibold transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                                onClick={handleExport}
                                disabled={exportLoading || dbQuestions.length === 0}
                            >
                                {exportLoading ? (
                                    <>
                                        <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                        Processing Export...
                                    </>
                                ) : (
                                    <>
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6h.1a5 5 0 011 9.9M12 8v8m0 0l-3-3m3 3l3-3" />
                                        </svg>
                                        Download JSON File
                                    </>
                                )}
                            </button>
                            
                            {dbQuestions.length === 0 && (
                                <p className="text-sm text-gray-500 mt-2">
                                    No questions available for export
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            </Modal>

            {/* Preview Questions Modal */}
            <Modal show={showPreviewModal} onHide={() => setShowPreviewModal(false)} size="xl" centered>
                <Modal.Header closeButton className="border-b border-gray-200">
                    <Modal.Title className="text-xl font-semibold flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                        Preview Questions ({previewData?.length || 0})
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    <div className="space-y-6">
                        {previewData?.map((question, index) => (
                            <div key={index} className="border border-gray-200 rounded-xl p-6 hover:shadow-md transition-shadow">
                                <div className="flex items-start gap-3 mb-4">
                                    <span className="bg-blue-100 text-blue-800 w-8 h-8 flex items-center justify-center rounded-full font-semibold text-sm">
                                        {index + 1}
                                    </span>
                                    <div className="flex-1">
                                        <div 
                                            className="mb-4 p-3 bg-gray-50 rounded-lg border"
                                            dangerouslySetInnerHTML={{ __html: question.question }} 
                                        />
                                        <div className="space-y-2">
                                            {question.options.map((option, optIndex) => (
                                                <div 
                                                    key={optIndex} 
                                                    className={`p-3 rounded-lg border ${
                                                        option.status ? 'bg-green-50 border-green-200' : 'bg-white border-gray-200'
                                                    } transition-colors`}
                                                >
                                                    <div className="flex items-center gap-3">
                                                        <span className={`w-6 h-6 flex items-center justify-center rounded text-sm font-medium ${
                                                            option.status ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-700'
                                                        }`}>
                                                            {option.option}
                                                        </span>
                                                        <span dangerouslySetInnerHTML={{ __html: option.content }} />
                                                        {option.status && (
                                                            <span className="ml-auto text-green-600 font-medium flex items-center gap-1">
                                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                                </svg>
                                                                Correct
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="mt-3 text-sm text-gray-600 font-medium">
                                            Correct answer: {question.answer}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-t border-gray-200">
                    <button
                        className="px-5 py-2.5 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors font-medium"
                        onClick={() => setShowPreviewModal(false)}
                    >
                        Cancel
                    </button>
                    <button
                        className="px-5 py-2.5 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors font-medium flex items-center gap-2 disabled:opacity-50"
                        onClick={dataUpload}
                        disabled={isProcessing}
                    >
                        {isProcessing ? (
                            <>
                                <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                Processing...
                            </>
                        ) : (
                            'Confirm and Upload'
                        )}
                    </button>
                </Modal.Footer>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <div className="bg-red-600 text-white p-6 rounded-t-lg">
                    <div className="flex justify-between items-center">
                        <h3 className="text-xl font-bold flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                            Confirm Delete
                        </h3>
                        <button 
                            onClick={() => setShowDeleteModal(false)}
                            className="text-white hover:text-gray-200 transition-colors"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>
                <div className="bg-white p-6">
                    <div className="bg-red-50 border-l-4 border-red-500 text-red-700 p-4 mb-6 rounded">
                        <p className="font-medium">Are you sure you want to delete this question?</p>
                        <p className="text-sm mt-1">This action cannot be undone.</p>
                    </div>
                    
                    {currentQuestion && (
                        <div className="border border-gray-200 rounded-lg p-4 mb-6 bg-gray-50">
                            <div className="text-sm text-gray-500 mb-2">Question Preview:</div>
                            <div dangerouslySetInnerHTML={{__html: currentQuestion.cbt_question}} />
                        </div>
                    )}
                    
                    <div className="flex justify-end gap-3">
                        <button 
                            className="px-5 py-2.5 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors font-medium"
                            onClick={() => setShowDeleteModal(false)}
                        >
                            Cancel
                        </button>
                        <button 
                            className="px-5 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium flex items-center gap-2"
                            onClick={() => {
                                if (currentQuestion) {
                                    deleteQuestion(currentQuestion);
                                }
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                            Delete Question
                        </button>
                    </div>
                </div>
            </Modal>
            
            <ToastContainer 
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </div>
    );
};

// Enhanced QuestionLoop Component
const QuestionLoop = forwardRef(({ i, question, onDeleteClick }, ref) => {
    const navigate = useNavigate();

    return (
        <div 
            className="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden mb-6 hover:shadow-md transition-all duration-200" 
            id={`question${i}`}
            ref={ref}
        >
            <div className="bg-gradient-to-r from-gray-50 to-white p-6">
                <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
                    <div className="flex items-center gap-4">
                        <div className="bg-blue-500 text-white w-10 h-10 flex items-center justify-center rounded-xl font-bold shadow-sm">
                            {i + 1}
                        </div>
                        <div>
                            <h3 className="text-lg font-semibold text-gray-800">Question {i + 1}</h3>
                            <div className="flex items-center gap-3 mt-1">
                                <span className="bg-blue-100 text-blue-800 px-2.5 py-1 rounded-full text-xs font-medium">
                                    Score: {question.score}
                                </span>
                                <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${
                                    question.cbt_question_status === 'published' 
                                        ? 'bg-green-100 text-green-800' 
                                        : 'bg-yellow-100 text-yellow-800'
                                }`}>
                                    {question.cbt_question_status}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="flex gap-2">
                        <button 
                            className="flex items-center gap-2 text-blue-600 hover:text-blue-800 px-4 py-2 border border-blue-600 rounded-xl transition-all duration-200 hover:bg-blue-50"
                            onClick={() => navigate(`/cbt_creator/cbt_question_edit?cbt_data_id=${question.cbt_data_id}&cbt_question_id=${question.cbt_question_id}`)}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                            Edit
                        </button>
                        <button 
                            className="flex items-center gap-2 text-red-600 hover:text-red-800 px-4 py-2 border border-red-600 rounded-xl transition-all duration-200 hover:bg-red-50"
                            onClick={() => onDeleteClick(question)}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                            Delete
                        </button>
                    </div>
                </div>
            </div>
            <div className="p-6">
                <div className="prose max-w-none" dangerouslySetInnerHTML={{__html: question.cbt_question}} />
            </div>
        </div>
    );
});

export { CbtData };